<template>
    <div class="create_class-root">
        <div class="main-content-wrap">
            <yioks-page-nav @backBtnHandle="backComfim=true;preTip=true" class="nav-wrap">
                <p class="title">选择学员名单（学员数量:{{commonStuList.length}}人）</p>
                <div class="nav-right" slot="right" v-if="commonStuList.length">
                    <p class="zuxie-btn" @click="chooseStu()">从继续教育报名中添加学员</p>
                </div>
            </yioks-page-nav>
            <div class="content-wrap">
                <vue-scroll :ops="createScrollOpt()">
                    <div class="form-wrap">
                        <yioks-loading v-if="isLoading"></yioks-loading>
                        <div class="table" v-show="!isLoading">
                            <template v-if="!commonStuList.length">
                                <div class="empty_wrap" >
                                    <yioks-empty h="350px" tips="暂时没有学员数据" ></yioks-empty>
                                    <div style="display: flex;justify-content: center">
                                        <p v-if="education_type === 'goalkeeper_education'" class="zuxie-btn" @click="chooseStu()">从守门员教练继续教育报名中添加学员</p>
                                        <p v-else class="zuxie-btn" @click="chooseStu()">从继续教育报名中添加学员</p>
                                    </div>
                                </div>
                            </template>
                           <template v-else>
                               <div v-if="commonStuList.length" class="item" v-for="(item,index) in commonStuList" :key="item.user_id" >
                                   <div class="tr" :class="item.error ? 'showError' : null ">
                                       <div class="td user">
                                           <div class="user_img">
                                               <img :src="item.profile_picture ? item.profile_picture  : User " @error="item.profile_picture=User" alt="">
                                           </div>
                                           <div class="user_name">
                                               <p :title="item.user_name +'（'+ (item.total_score ? item.total_score : '--') + '分）'">{{item.user_name}} <span v-if="item.is_high_player" style="color:#FAF408;font-weight:bold" title="高水平职业球员认证"> (G)</span>（{{item.total_score || '--'}}分）</p>
                                               <img :src="item.gender==='Female' ? female :male"  alt="">
                                           </div>
                                       </div>
                                       <div class="td phone">
                                           <p>手机号：{{item.mobile_phone}}</p>
                                       </div>
                                       <div class="td xiehui">
                                           <p>注册足协:{{item.org_abbreviation || '--'}}</p>
                                       </div>
                                       <div class="td id_num">
                                           <p>证件号：</p>
                                           <p>{{item.id_number}}</p>
                                       </div>
                                       <div class="td enroll_name">
                                           <p :title="item.enroll_name" style="cursor: pointer"> {{item.enroll_name}}</p>
                                       </div>
                                       <div class="td opt">
                                           <p  class="look" >
                                               <span class="detail" @click="lookSignUp(item.uid,item.enroll_uuid)">详情</span>
                                               <span style="margin: 0 15px">/</span>
                                               <span class="history" @click="lookHistory(item.uid)">历程</span>
                                           </p>
                                       </div>
                                       <div class="error" v-if="item.error" :title="item.errmsg" >{{item.errmsg}}</div>
                                        <div class="close_btn">
                                            <i class="el-icon-close icon_close" @click="removeStu(index,'continue_education')"></i>
                                        </div>
                                   </div>

                               </div>
                               <yioks-empty  tips="暂时没有学员" v-if="!commonStuList.length" h="30%" ></yioks-empty>
                           </template>
                        </div>
                    </div>
                </vue-scroll>
            </div>
            <div class="post-btn">
                <el-button  type="primary" :disabled="disabled" @click="submit('Back')">上一步</el-button>
                <el-button  type="primary" :disabled="disabled" @click="submit('Edit')">暂时保存</el-button>
                <el-button type="primary" :disabled="disabled" @click="submit('Initiated')">提交</el-button>
                <el-button type="danger"  @click="backComfim=true">取消</el-button>
            </div>
        </div>
        <template v-if="ifDiaShow">
            <el-dialog
                    class="detail-info-dia"
                    title="详细信息"
                    :visible.sync="ifDiaShow"
                    :close-on-click-modal="false"
                    width="750px"
                    top="12vh"
            >
                <div class="scroll-wrap">
                    <vue-scroll :ops="createScrollOpt(true)" ref="vScroll">
                        <div class="stu-info-box">
                            <stu-detail-info :info='curStuInfo'></stu-detail-info>
                        </div>
                    </vue-scroll>
                </div>
            </el-dialog>
        </template>
        <template v-if="showHistory">
            <yioks-history :showHistory.sync="showHistory" :coachHistoryInfo="coachHistoryInfo" :loading="historyLoading" :list="list" ></yioks-history>
        </template>
        <template v-if="showHistoryFromAll">
            <yioks-history-drawer :showHistory.sync="showHistoryFromAll" :coachHistoryInfo="coachHistoryInfo"  :loading="historyLoading" :list="list"></yioks-history-drawer>
        </template>
        <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="backComfimDialog"></yioks-tips>
        <yioks-tips :showTips="showTips" :tips="tipsMsg" :loading="Loading" @hideTips="commitData"></yioks-tips>
        <template v-if="showPeopleDialog">
            <el-dialog
                    :visible.sync="showPeopleDialog"
                    :close-on-click-modal="false"
                    top="13vh"
                    width="1024px"
                    class="people-scroll yi-dialog-root "
            >

                <div class="mainPeopleWrap">
                    <div class="slot-dialog-header" slot="title">
                        <span class="title">录入学员名单</span>
                    </div>
                    <div class="searchWrap">
                        <div class="selectWrap">
                            <select v-model="selectVal.enroll_id"
                                    @change="change_enroll_id"
                                    >
                                <option v-for="(item, index) in enroll_list"
                                        :key="index"
                                        :value="item.enroll_id"
                                >{{ item.enroll_name }}
                                </option>
                            </select>
                        </div>
                        <div class="selectWrap" v-if="time_change_way === 'month'">
                            <select v-model="selectVal.intention_date"
                              @change="change_intention_date"
                            >
                                <option value="">选择意向参加时间</option>
                                <option v-for="(item, index) in intention_class_dates"
                                  :key="index"
                                  :value="item.value">{{ item.label }}
                                </option>
                            </select>
                        </div>
                        <div class="selectWrap" v-if="time_change_way === 'periods'">
                            <select v-model="selectVal.intention_date"
                              @change="change_intention_date"
                            >
                                <option value="">选择意向参加期数</option>
                                <option v-for="(item, index) in intention_class_periods"
                                  :key="index"
                                  :value="item.value">{{ item.label }}
                                </option>
                            </select>
                        </div>
                        <div class="selectWrap">
                            <select v-model="selectVal.org_id"
                              @change="change_intention_date"
                            >
                                <option value="">选择注册足协</option>
                                <option v-for="(item, index) in organization"
                                  :key="index"
                                  :value="item.org_id">{{ item.name }}
                                </option>
                            </select>
                        </div>
                        <div class="selectWrap">
                            <select v-model="selectVal.admit_status"
                              @change="changeAdminStatus"
                            >
                                <option value="">关注度</option>
                                <option value="none_star">未评星</option>
                                <option v-for="(item, index) in selectListForSignStu"
                                  :key="index"
                                  :value="item.value">{{ item.key }}
                                </option>
                            </select>
                        </div>
                        <div class="selectWrap">
                            <select v-model="selectVal.order_way"
                              @change="changeAdminStatus"
                            >
                                <option value>默认排序</option>
                                <option value="desc">分数降序</option>
                                <option value="asc">分数升序</option>
                            </select>
                        </div>
                            <div
                                v-if="isShowAddressSearch"
                                class="live-address"
                            >
                            <el-popover
                                placement="bottom"
                                width="350"
                                v-model="isShowAddress"
                            >
                                <el-form :inline="true" ref="searchAddressForm" :model="searchAddressForm" label-width="80px">
                                    <el-form-item label="省份">
                                    <el-select v-model="searchAddressForm.province_id" clearable @change="updateCity" placeholder="请选择省份">
                                        <el-option v-for="(item, index) in area_list" :key="index" :label="item.regionName" :value="item.id"></el-option>
                                    </el-select>
                                    </el-form-item>
                                    <el-form-item label="市">
                                    <el-select v-model="searchAddressForm.city_id" clearable placeholder="请选择市">
                                        <el-option v-for="(item, index) in city_list" :key="index" :label="item.regionName" :value="item.id"></el-option>
                                    </el-select>
                                    </el-form-item>
                                </el-form>
                                <div class="btns-list">
                                <div class="btn suc" @click="handleSearchAddress">筛选</div>
                                <div class="btn primary" @click="handleClearSearchAddress">清除筛选</div>
                                </div>
                                <el-button type="text" slot="reference"
                                >现居住地</el-button
                                >
                                <!--<el-button type="primary"  slot="reference" icon="el-icon-search">空闲</el-button>-->
                            </el-popover>
                        </div>
                        <div class="search">
                            <div class="wrap yioks-wrapper"  style="border: none">
                                <!-- <input type="text"
                                       placeholder="请输入搜索内容"
                                       v-model.lazy="selectVal.keywords"
                                      >
                                <div v-show="selectVal.keywords!=''"
                                     class="close"
                                     @click="clearKeywords()"
                                    >
                                    <v-icon name="regular/times-circle"
                                            scale="1.2"></v-icon>
                                </div> -->
                                 <el-autocomplete
                                    class="inline-input"
                                    v-model="selectVal.keywords"
                                    :fetch-suggestions="querySearch"
                                    placeholder="请输入搜索内容"
                                    @keyup.enter.native="handleBtnSearch"
                                    @select="handleSearch"
                                ></el-autocomplete>
                            </div>
                            <div class="searchBtn"
                                 @click="search"
                                 >搜索
                            </div>
                            <div class="searchBtn" style="margin-left:10px"
                              @click="allChoose"
                              v-if="chooseStuList.length"
                            >全选
                            </div>
                            <div class="searchBtnNo" style="margin-left:10px"
                              v-else
                            >全选
                            </div>
                        </div>
                    </div>
                    <yioks-loading  v-show="loading"></yioks-loading>
                    <div class="dialog-content"  v-if="!loading">
                        <vue-scroll :ops="createScrollOpt(true)" ref="stuVs">
                            <div class="dia-scroll-content">
                                <div class="empty_wrap" v-if="!chooseStuList.length">
                                    <yioks-empty-gray h="400px" ></yioks-empty-gray>
                                </div>
                                <div class="table" v-if="chooseStuList.length">
                                    <div class="thead">
                                        <div class="tr">
                                            <div class="th name" style="color:#606266"><strong>姓名(未录取次数)</strong></div>
                                            <div class="th mobile_phone"><strong>手机号</strong></div>
                                            <div class="th id_number"><strong>证件号</strong></div>
                                            <div class="th enroll_name"><strong>查看</strong></div>
                                            <div class="th type"><strong>意向参加时间</strong></div>
                                            <div class="th admin_status"><strong>关注度</strong></div>
                                            <div class="th socre"><strong>分数</strong></div>
                                            <div class="th opt"><strong>操作</strong></div>
                                        </div>
                                    </div>
                                    <div class="scrollArea" >
                                        <vue-scroll :ops="createScrollOpt(true)" ref="vs">
                                            <div class="tbodyWrap">
                                                <div class="tbody">
                                                    <div class="tr"
                                                         style="position: relative"
                                                         v-for="(item, index) in chooseStuList"
                                                         :key="index">
                                                        <div class="td name" >
                                                            <p style="width: 20%;text-align: center">{{index + 1}}</p>
                                                            <p style="width: 55%;text-align: center">{{ item.name }} <span v-if="item.is_high_player" style="color:#f88594;font-weight:bold" title="高水平职业球员认证">(G)</span></p>
                                                            <p style="width: 25%;text-align: center">({{ item.enroll_num }})</p>
                                                        </div>
                                                        <div class="td mobile_phone">
                                                            <p>{{item.mobile_phone || '--'}}</p>
                                                        </div>
                                                        <div class="td id_number">
                                                            <p>{{ item.id_number||"--" }}</p>
                                                        </div>
                                                        <div class="td enroll_name">
                                                            <p  class="item detail" @click="lookDetail(item.uid,item.enroll_uuid)" > 详情</p>
                                                            <p style="margin: 0 5px">/</p>
                                                            <p class="item history" @click="lookHistoryFromAll(item.uid)">历程</p>
                                                        </div>
                                                        <div class="td type flex-column" v-if="item.time_change_way ==='periods'">
                                                            <!-- <p :title="item.intention_class_date">{{item.intention_class_date | intentionClassDate}}</p> -->
                                                            <p :title="item.intention_class_periods_one | intention_class_date_periods_filter " v-if="item.intention_class_periods_one" style="width: 100%">{{item.intention_class_periods_one | intention_class_date_periods_filter }}</p>
                                                            <p :title="item.intention_class_periods_two | intention_class_date_periods_filter " v-if="item.intention_class_periods_two" style="width: 100%">{{item.intention_class_periods_two | intention_class_date_periods_filter }}</p>
                                                        </div>
                                                        <div class="td type flex-column" v-if="item.time_change_way ==='month'">
                                                            <!-- <p :title="item.intention_class_date">{{item.intention_class_date | intentionClassDate}}</p> -->
                                                            <p :title="item.intention_class_date_one">{{item.intention_class_date_one}}</p>
                                                            <p :title="item.intention_class_date_two">{{item.intention_class_date_two}}</p>
                                                        </div>
                                                        <div class="td admin_status">
                                                           <p>{{item.admit_status | adminFilters}}</p>
                                                        </div>
                                                        <div class="td socre">
                                                            <p>{{item.total_score || '--'}}</p>
                                                        </div>
                                                        <div class="td opt" >
                                                           <el-button v-if="item.isDisabled || item.user_id in selectedStuObj" icon="el-icon-remove-outline"   type="danger" size="small"  @click="removeStuFromAll(index,item.enroll_type,item.user_id)">移出</el-button>
                                                            <el-button v-else  icon="el-icon-circle-plus" type="primary" size="small" @click="addStu(index,item)">添加</el-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </vue-scroll>
                                    </div>
                                </div>
                            </div>
                        </vue-scroll>
                    </div>
                    <div v-if="!loading" style="display: flex;justify-content: center;align-items: center;margin-bottom: 5px">
                        <p>已选择人员：{{commonStuList.length}}人</p>
                        <el-button size="mini" type="primary" style="margin-left: 30px" @click="showPeopleDialog=false">关闭</el-button>
                    </div>
                </div>
            </el-dialog>
        </template>
        <drawer-info :showDrawer.sync="showInfo" :info="curStuInfo"></drawer-info>
        <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
    </div>
</template>
<script>
    import { getStuHistoryTrian} from "@/api/system_manager/api";
    import { class_student ,all_enroll_list,to_choose_student,verify_class_student,education_create_two} from "@/api/education/education";
    import createScrollOpt from "@/assets/js/vuescrollOption";
    import { adminFilters,intention_class_date_periods_filter } from "@/assets/js/yioksFilters";
    import { selectListForSignStu } from "@/assets/js/select";
    import commonFun from "@/assets/js/yioks";
    import User from "@/assets/images/person.png";
    import { info_view } from "@/api/ab_signup/api";
    import male from "@/assets/images/male.png";
    import "vue-awesome/icons/regular/file-alt";
    import female from "@/assets/images/female.png";
    const { mobile_phone, idCard_number,email } = commonFun;
    import { area_list } from "@/assets/js/region";
    import identify1 from "@/assets/images/vita/identify1.png";
    import identify2 from "@/assets/images/vita/identify2.png";
    import avatorImg from "@/assets/images/person.png";
    import yioksStorage from '@/assets/js/yioksStorage';
    const HOSTURL = process.env.VUE_APP_URL;
    const SELECTSUGGESTIONlIST = 'suggestionList'
    export default {
        name: "EducationCrateSecond",

        data() {
            return {
                
                selectListForSignStu,
                preTip:false,
                showInfo:false,
                showHistory:false,
                disabled:false,
                tipsMsg:'',
                Loading:false,
                showTips:false,
                ifDiaShow:false,
                PostData:{},
                list:[],
                organization: [],
                intention_class_dates:[],
              intention_class_periods: [],
                User,
                edu_id:this.$route.query.edu_id,
                education_type:this.$route.query.education_type,
                status:'Edit',
                male,
                coachHistoryInfo: {
                    coachUser: {},
                    ranks: [],
                    certificates: [],
                    achievemens: [],
                    rankList: [],
                },
                curStuInfo: {
                    studentSingnInfo: {},
                    enrollMap: {},
                    report_list:[],
                    language_list: [],
                    academic_data: [],
                    coach_data: [],
                    experience_data: [],
                    playing_data: []
                },
                enroll_type:'',
                loading:true,
                female,
                backComfim:false,
                enroll_list:[],
                errStuList:[], //错误学员列表
                commonStuList:[],
                historyLoading:false,
                showAdd:true,
                isLoading:false,
                chooseStuList:[],
                selectedStuObj:{},// 已选择学员对象
                showPeopleDialog:false,
                showHistoryFromAll:false,
                selectVal:{
                  enroll_id:'',
                  intention_date:'',
                  org_id:'',
                  admit_status:'',
                  order_way:'',
                  keywords:''
                },
              time_change_way:'month',
                createScrollOpt,
                // 表示是否是由批量录入弹窗中的保存按钮调起的录入名单弹窗
                
                searchAddressForm: {
                    province_id: '',
                    city_id: '',
                },
                area_list,
                city_list: [],
                isShowAddress: false,
                isShowAddressSearch: false,
            };
        },

        watch: {
            showPeopleDialog(newVal, oldVal) {
                if(!newVal) {
                    this.searchAddressForm = {
                        province_id: '',
                        city_id: '',
                    }
                }
            }
        },
        computed: {
        
        },
        created() {
            this.getStuList();
        },
      filters: {
        adminFilters,
        intention_class_date_periods_filter,
        intentionClassDate(dates){
          let str = '';
          if(dates && dates!== '[]'){
            const dataList =JSON.parse(dates);
            for(let i = 0 ; i < dataList.length ; i++){
              str +=  dataList[i] + '，';
            }
            if(str !== ''){
              str = str.substring(0,str.length-1);
            }else{
              str = '--';
            }
          }else{
            str = '--';
          }
          return str;
        }
      },
        components:{
            "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
            "yioks-tips": () => import('@/components/Tips/Dialog'),
            "yioks-history": () => import('@/components/History/history'),
            "yioks-history-drawer": () => import('@/components/History/history-drawer'),
            "yioks-empty": () => import("@/components/Tips/Empty"),
            "yioks-empty-gray": () => import("@/components/Tips/Empty-grey"),
            "yioks-loading": () => import("@/components/Loading/Loading"),
            "v-icon": () => import("vue-awesome/components/Icon"),
            "stu-detail-info": () => import("@/components/EnrollPersonnelInfo/EnrollPersonnelInfo"),
            "drawer-info": () => import("@/components/Drawer/drawerInfo"),
        },
        methods: {
          
            change_enroll_id(val){
              // 得到选中哪一个了
              const res = this.enroll_list.filter(item => {
                if(item.enroll_id == this.selectVal.enroll_id) {
                  this.time_change_way = item.time_change_way;
                  return item
                }
              });
              // 选中的这个 是否需要选择意向参加时间
              this.intention_class_dates = [];
              if(res[0].is_choose_classDate && this.time_change_way==='month'){
                // let class_starts = this.$yioks.time(res[0].class_start);
                // let class_ends = this.$yioks.time(res[0].class_end);
                // this.intention_class_dates = this.$yioks.getMonthBetween(class_starts,class_ends)
                const { classPhase } = res[0];
                classPhase.forEach(item => {
                    const { start_date, end_date } = item;
                    const momentJs = require('moment');
                    const lebelName = `${momentJs(start_date).format('yyyy-MM')} 至 ${momentJs(end_date).format('yyyy-MM')}`;
                    for(let i = 0; i < 1; i ++) {
                        const seq = ['一', '二'];
                        const tentionMonthList = {
                            label: `${lebelName}`,
                            value: JSON.stringify({
                            intention_class_date: lebelName
                            })
                        }
                        this.intention_class_dates.push(tentionMonthList)
                    }
                })
              }
              // 选中的这个 是否需要选择意向参加期数
              this.intention_class_periods = [];
              if(res[0].is_choose_classDate && this.time_change_way==='periods'){
                const { classPhase } = res[0];
                classPhase.forEach((item,index) => {
                  const { start_date, end_date,start_date_two,end_date_two,province_name,city_name } = item;
                  const momentJs = require('moment');
                  let lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM")}，阶段二：${momentJs(end_date).format("yyyy-MM")}`;
                  let value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM")},${momentJs(end_date).format("yyyy-MM")}`;
                  if(start_date_two){
                    lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM-DD")} 至 ${momentJs(end_date).format("yyyy-MM-DD")}，阶段二：${momentJs(start_date_two).format("yyyy-MM-DD")} 至 ${momentJs(end_date_two).format("yyyy-MM-DD")}`;
    
                    value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM-DD")}至${momentJs(end_date).format("yyyy-MM-DD")},${momentJs(start_date_two).format("yyyy-MM-DD")}至${momentJs(end_date_two).format("yyyy-MM-DD")}`;
                  }
                  if(province_name){
                    lebelName = lebelName + "，" + province_name + city_name;
                    value1 = value1 + "," + province_name + city_name;
                  }
                  lebelName = lebelName+'）';
                  for(let i = 0; i < 1; i ++) {
                    const seq = ['一', '二'];
                    const tentionMonthList = {
                      label: `${lebelName}`,
                      value: JSON.stringify({
                        intention_class_date: value1
                      })
                    }
                    this.intention_class_periods.push(tentionMonthList)
                  }
                })
              }
                if(res[0].is_need_live_address) {
                    this.isShowAddressSearch = true;
                } else {
                    this.isShowAddressSearch = false;
                }
              // 清空意向选择时间
              if(this.selectVal.intention_date) this.$set(this.selectVal, 'intention_date', '');
              this.get_choose_student_list();
            },
          change_intention_date(val){
            this.get_choose_student_list();
          },
          changeAdminStatus() {
            this.get_choose_student_list();
          },
            chooseStu(){
                this.enroll_type=this.education_type;
                this.showPeopleDialog=true;
                this.get_enroll_list()
            },
            clearKeywords(){
                this.selectVal.keywords='';
                this.get_choose_student_list();
            },
            submit(status){
                this.disabled=true
              this.status=status
              if (status==='Back'){
                  this.tipsMsg='确定暂时保存并返回上一步吗？'
              } else if(status==='Initiated'){
                  this.tipsMsg='确定保存并提交吗？'
              }else if (status==='Edit'){
                  this.tipsMsg='确定暂时保存并退出吗？'
              }
              this.commit(status)
            },
            search(){
                this.get_choose_student_list()
            },
          allChoose(){
            this.chooseStuList.forEach((element,index) => {
              this.$set(this.chooseStuList[index],'isDisabled',true)
              // 没有被选过的 再加
              if(!this.selectedStuObj[this.chooseStuList[index].user_id]){
                this.commonStuList.push(this.chooseStuList[index])
                this.selectedStuObj[this.chooseStuList[index].user_id]=this.chooseStuList[index].user_id
              }
            });
            this.$message.success('添加成功')
          },
            commit(status){
                let commonData=[];
                if (this.commonStuList.length>0){
                    this.commonStuList.forEach((item,index)=>{
                        commonData.push({
                            id:index,
                            enroll_uuid:item.enroll_uuid,
                            user_id:item.user_id,
                            id_number:item.id_number,
                            enroll_type:item.enroll_type,
                        })
                    })
                }

                if(this.commonStuList.length < 1 && status==='Initiated'){
                    this.showTips=false
                    this.Loading=false
                    this.disabled=false
                    this.$message.error('暂时没有选择学员')
                    return
                } else{
                    this.commonStuList.forEach((item,index)=>{
                        this.$set(this.commonStuList[index],'error',false)
                        this.$set(this.commonStuList[index],'errmsg','')
                    })
                    
                    this.testStuList(JSON.stringify(commonData),status)
                }
            },
            testStuList(student_list,status){
                const PostData={
                    status,
                    edu_id:this.edu_id,
                    student_list
                };
                verify_class_student(PostData).then(res=>{
                    if (Number(res.data.status)===0) {
                        const {consequence, studentErr,stuHintList} = res.data.result;
                        this.errStuList = studentErr;
                        if (consequence !== 'OK') {
                            this.errStuList.forEach((item, index) => {
                                
                                    this.$set(this.commonStuList[Number(item.index_id)], 'error', true)
                                    this.$set(this.commonStuList[Number(item.index_id)], 'errmsg', Object.values(item.err).join(','))
                            });
                            this.Loading = false;
                            this.showTips = false;
                            this.disabled=false
                            this.$message.error('学员名单有误，请检查学员信息')
                        } else {
                            this.PostData=PostData;
                            if (stuHintList.length>0){
                                this.tipsMsg = "学员名单中【" + stuHintList.slice(0, 3) + (stuHintList.length > 3 ? `等${stuHintList.length}人` : '') + "】曾经参加过此类培训，请确认是否继续提交？";
                            }
                            this.showTips=true
                            this.disabled=false
                            //
                        }
                    }else{
                        this.$message.error(res.data.msg)
                        this.isLoading=false
                        this.disabled=false
                        this.showTips=false
                    }
                }).catch(err=>{
                    this.isLoading=false
                    this.disabled=false
                    this.showTips=false
                })
            },
            addStu(index){
              this.$set(this.chooseStuList[index],'isDisabled',true)
              this.commonStuList.push(this.chooseStuList[index])
              this.selectedStuObj[this.chooseStuList[index].user_id]=this.chooseStuList[index].user_id
              this.$message.success('添加成功')
              
//                    if (this.commonStuList.length >= 500){
//                        this.$message.error('最多可添加500名报名学员')
//                    }else{
//                        this.$set(this.chooseStuList[index],'isDisabled',true)
//                        this.commonStuList.push(this.chooseStuList[index])
//                        this.selectedStuObj[this.chooseStuList[index].user_id]=this.chooseStuList[index].user_id
//                        this.$message.success('添加成功')
//                    }
            

            },
            removeStuFromAll(index,type,id){
                
                    this.commonStuList.map((item,index)=>{
                        if (item.user_id===id){
                            delete this.selectedStuObj[this.commonStuList[index].user_id]
                            this.commonStuList.splice(index,1)
                        }
                        return item ;
                    })
                
                this.$set(this.chooseStuList[index],'isDisabled',false)
                this.$message.warning('移出成功')
            },
            get_enroll_list(){
                all_enroll_list({
                    edu_id:this.edu_id,
                }).then(res=>{
                    if (Number(res.data.status)===0){
                        const { enroll_list } =res.data.result;
                      this.intention_class_dates = [];
                      this.intention_class_periods = [];
                        if (enroll_list.length>0){
                            this.enroll_list=enroll_list
                            this.selectVal.enroll_id=enroll_list[0].enroll_id
                            if(enroll_list[0].is_need_live_address) {
                                this.isShowAddressSearch = true
                            } else {
                                this.isShowAddressSearch = false
                            }
                          this.time_change_way = enroll_list[0].time_change_way;
                            this.get_choose_student_list()
                          // 如果报名让选意向时间了 就显示
                          if(enroll_list[0].is_choose_classDate && this.time_change_way==='month'){
                            // let class_starts = this.$yioks.time(enroll_list[0].class_start);
                            // let class_ends = this.$yioks.time(enroll_list[0].class_end);
                            // this.intention_class_dates = this.$yioks.getMonthBetween(class_starts,class_ends)
                            this.intention_class_dates = [];
                            const { classPhase } = enroll_list[0];
                            classPhase.forEach(item => {
                                const { start_date, end_date } = item;
                                const momentJs = require('moment');
                                const lebelName = `${momentJs(start_date).format('yyyy-MM')} 至 ${momentJs(end_date).format('yyyy-MM')}`;
                                for(let i = 0; i < 1; i ++) {
                                    const seq = ['一', '二'];
                                    const tentionMonthList = {
                                        label: `${lebelName}`,
                                        value: JSON.stringify({
                                        intention_class_date: lebelName
                                        })
                                    }
                                    this.intention_class_dates.push(tentionMonthList)
                                }
                            })

                          }
                          if(enroll_list[0].is_choose_classDate && this.time_change_way==='periods'){
                            // let class_starts = this.$yioks.time(enroll_list[0].class_start);
                            // let class_ends = this.$yioks.time(enroll_list[0].class_end);
                            // this.intention_class_dates = this.$yioks.getMonthBetween(class_starts,class_ends)
                            this.intention_class_periods = [];
                            const { classPhase } = enroll_list[0];
                            classPhase.forEach((item,index) => {
                              const { start_date, end_date,start_date_two,end_date_two,province_name,city_name } = item;
                              const momentJs = require('moment');
                              let lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM")}，阶段二：${momentJs(end_date).format("yyyy-MM")}`;
                              let value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM")},${momentJs(end_date).format("yyyy-MM")}`;
                              if(start_date_two){
                                lebelName = '选择'+`${index+1}`+'（阶段一：'+`${momentJs(start_date).format("yyyy-MM-DD")} 至 ${momentJs(end_date).format("yyyy-MM-DD")}，阶段二：${momentJs(start_date_two).format("yyyy-MM-DD")} 至 ${momentJs(end_date_two).format("yyyy-MM-DD")}`;
    
                                value1 = `${index+1}`+','+`${momentJs(start_date).format("yyyy-MM-DD")}至${momentJs(end_date).format("yyyy-MM-DD")},${momentJs(start_date_two).format("yyyy-MM-DD")}至${momentJs(end_date_two).format("yyyy-MM-DD")}`;
                              }
                              if(province_name){
                                lebelName = lebelName + "，" + province_name + city_name;
                                value1 = value1 + "," + province_name + city_name;
                              }
                              lebelName = lebelName+'）';
                              for(let i = 0; i < 1; i ++) {
                                const seq = ['一', '二'];
                                const tentionMonthList = {
                                  label: `${lebelName}`,
                                  value: JSON.stringify({
                                    intention_class_date: value1
                                  })
                                }
                                this.intention_class_periods.push(tentionMonthList)
                              }
                            })
    
                          }
                        }else{
                            this.loading=false
                            this.chooseStuList=[];
                            this.enroll_list=[];
                            this.$set(this.selectVal,'enroll_id','');
                            this.intention_class_dates = [];
                        }
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            get_choose_student_list(){
                this.loading=true
                let queryData = {
                    edu_id:this.edu_id,
                    enroll_id:this.selectVal.enroll_id,
                    // intention_date:this.selectVal.intention_date,
                    org_id:this.selectVal.org_id,
                    enroll_type:this.enroll_type,
                    admit_status:this.selectVal.admit_status,
                  order_way:this.selectVal.order_way,
                    keywords:this.selectVal.keywords,
                    province_id:this.searchAddressForm.province_id,
                    city_id:this.searchAddressForm.city_id,
                }
                if(this.selectVal.intention_date) {
                    const { intention_class_date, intention_num } = JSON.parse(this.selectVal.intention_date);
                    queryData = {
                        ...queryData,
                        intention_date: intention_class_date,
                        intention_num
                    }
                } else {
                    queryData = {
                        ...queryData,
                        intention_date: '',
                        intention_num: ''
                    }
                }

                to_choose_student(queryData).then(res=>{
                    if (res.data.status===0){
                        this.loading=false
                        const {list,page}=res.data.result
                        this.chooseStuList=list
                    }else{
                        this.loading=false
                    }
                }).catch(err=>{
                    this.loading=false
                })
            },
            getStuList(){
                class_student({
                  edu_id:this.edu_id
                }).then(res=>{
                    if (Number(res.data.status)===0){
                        const {studentData}=res.data.result
                        if (studentData.length > 0){
                            studentData.forEach((item,index)=>{
                              
                              this.commonStuList.push(item)
                              
                                this.selectedStuObj[item.user_id]=item.user_id;
                            })
                        }
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            backComfimDialog(bool, sure) {
                this.backComfim = bool;
                if (sure) {
                  this.$router.push({
                    path: 'education_crate_one',
                    query: {
                      edu_id: this.edu_id,
                    }
                  })
                  
//                  this.$router.go(-1);
                }
            },
            commitData(bool,sure){
                if (sure){
                    this.Loading=true
                  education_create_two(this.PostData).then(res => {
                        this.Loading = false;
                        this.showTips = false;
                        switch (this.status) {
                            case 'Back' :
                              this.$router.push({
                                path: 'education_crate_one',
                                query: {
                                  edu_id: this.edu_id,
                                }
                              })
//                              this.$router.go(-1);
                                break;
                            case 'Edit' :
                              this.$message.success('培训班暂时保存成功');
                              this.$router.push({
                                path: 'education_detail',
                                query: {
                                  edu_id: this.edu_id,
                                  type:"edit"
                                }
                              })
//                              this.$router.go(-2);
                                break;
                            case 'Initiated' :
                                this.$message.success('培训班提交成功');
                              this.$router.push({
                                path: 'education_detail',
                                query: {
                                  edu_id: this.edu_id,
                                  type:"edit"
                                }
                              })
//                              this.$router.go(-2);
                                break;
                        }
                    }).catch(err => {
                        this.Loading = false;
                        this.showTips = false;
                        console.log(err)
                    })
                } else{
                    this.Loading=false;
                    this.showTips=bool
                }
            },
            removeStu(index,type){
              
                    delete this.selectedStuObj[this.commonStuList[index].user_id]
                    this.commonStuList.splice(index,1)
                
            },
            lookHistory(uid){
                if (this.showHistory) return;
                this.showHistory=true;
                this.getStuHistoryTrianList(uid)
            },
            lookHistoryFromAll(uid){
                if (this.showHistoryFromAll) return;
                this.showHistoryFromAll=true;
                this.getStuHistoryTrianList(uid)
            },
            getStuHistoryTrianList(uid) {
                this.list=[];
                this.historyLoading=true
                getStuHistoryTrian({
                    uid
                })
                    .then(res => {
                        const { result } = res.data;

                        if (result.coachHistoryInfo) {
                            const {coachUser, ranks, certificates, achievemens, score} = result.coachHistoryInfo;
                            if (coachUser) this.coachHistoryInfo.coachUser = coachUser; // 获取用户信息
                            if (ranks) this.coachHistoryInfo.ranks = ranks; // 获取等级
                            if (certificates) this.coachHistoryInfo.certificates = certificates; //获取证书
                            if (achievemens) this.coachHistoryInfo.achievemens = achievemens; //获取成绩信息
                            // 处理证书
                            let certificateInfo = {};
                            if (certificates.length > 0) {
                                for (let i = 0; i < certificates.length; i++) {
                                    const {rankId} = certificates[i];
                                    certificateInfo[rankId] = certificates[i];
                                }
                            }
                            // 处理成绩
                            let achievemensInfo = {};
                            if (achievemens.length > 0) {
                                for (let i = 0; i < achievemens.length; i++) {
                                    const {rankId} = achievemens[i];
                                    achievemensInfo[rankId] = achievemens[i];
                                }
                            }
                            // 合并成绩
                            if (ranks.length > 0) {
                                for (let j = 0; j < ranks.length; j++) {
                                    const {id} = ranks[j];
                                    if (score && score[achievemensInfo[id]["id"]]){
                                        ranks[j]['score']=score[achievemensInfo[id]["id"]]
                                    };
                                    ranks[j].is_old = 1;
                                    if (certificateInfo[id]) {
                                        const {certificateNum, certificateDate, validityStart,certificateUrl} = certificateInfo[id];
                                        ranks[j].certificateNum = certificateNum;
                                        ranks[j].certificateDate = certificateDate;
                                        ranks[j].validityStart = validityStart;
                                        if (certificateUrl) ranks[j].certificateUrl = certificateUrl;
                                    }
                                    if (achievemensInfo[id]) {
                                        const {classAddress, classEnd, classStart, lecturerName, classUid,continueCumulativeHours} = achievemensInfo[id];
                                        ranks[j].classAddress = classAddress;
                                        ranks[j].classEnd = classEnd;
                                        ranks[j].classStart = classStart;
                                        ranks[j].lecturerName = lecturerName;
                                        ranks[j].classUid = classUid;
                                        ranks[j].end_date = new Date(classEnd).getTime();
                                        ranks[j].continueCumulativeHours = continueCumulativeHours;
                                        this.list.push(ranks[j]);
                                    }
                                }
                            }
                            if (this.list) this.list =  this.list.sort((pre, next) => {
                                return next.end_date - pre.end_date;
                            });

                        }
                        this.historyLoading=false
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            lookSignUp(uid,enroll_uuid){
                if (this.ifDiaShow) return;
                this.ifDiaShow = true;
                this.getPersonnelInfo(uid,enroll_uuid);
            },
            lookDetail(uid,enroll_uuid){
                if (this.showInfo)return;
                this.showInfo = true;
                this.getPersonnelInfo(uid,enroll_uuid);

            },
            getPersonnelInfo(uid,enroll_uuid) {
                info_view({ uuid: uid,enroll_uuid }).then(({ data }) => {
                    if (data.status === 0) {
                        const { result } = data;
                        this.curStuInfo.studentSingnInfo = {
                            ...result.studentSingnInfo,
                            id_card_photo_front: result.studentSingnInfo.id_card_photo_front
                                ? HOSTURL + result.studentSingnInfo.id_card_photo_front
                                : identify1,
                            id_card_photo_verso: result.studentSingnInfo.id_card_photo_verso
                                ? HOSTURL + result.studentSingnInfo.id_card_photo_verso
                                : identify2,
                            profile_picture: result.studentSingnInfo.profile_picture
                                ? HOSTURL + result.studentSingnInfo.profile_picture
                                : avatorImg
                        };
                        for (const key in this.studentSingnInfo) {
                            if (this.studentSingnInfo.hasOwnProperty(key)) {
                                const element = this.studentSingnInfo[key];
                                this.studentSingnInfo[key] = element || "--";
                            }
                        }

                        this.curStuInfo.language_list = [...result.language_list];
                        this.curStuInfo.academic_data = [...result.academic_data];
                        this.curStuInfo.coach_data = [...result.coach_data];
                        this.curStuInfo.experience_data = [...result.experience_data];
                        this.curStuInfo.experience_data_not = [...result.experience_data_not];
                        this.curStuInfo.playing_data = [...result.playing_data];
                        this.curStuInfo.enrollMap = {...result.enrollMap};
                        this.curStuInfo.report_list = [...result.report_list];
                      if (this.curStuInfo.studentSingnInfo.student_information === 'Active' && !this.curStuInfo.studentSingnInfo.total_score && result.experience_data_backup.length > 0 ){
                        this.curStuInfo.experience_data = [...result.experience_data_backup];
                      }
                    //   let take_place = '';
                    //   if(this.curStuInfo.studentSingnInfo.take_place && this.curStuInfo.studentSingnInfo.take_place !== '无'){
                    //     const temList = JSON.parse(this.curStuInfo.studentSingnInfo.take_place)
                    //     temList.forEach(letTmp =>{
                    //       if(letTmp){
                    //         let tmp1 = letTmp[0];
                    //         for(var x = 1;x<letTmp.length ; x++){
                    //           if(letTmp[x]){
                    //             tmp1 = tmp1 + '/' + letTmp[x] ;
                    //           }
                    //         }
                    //         take_place = take_place + tmp1 + '，';
                    //       }
                    //     })
                    //     take_place = take_place.substr(0, take_place.length - 1);
                    //     this.curStuInfo.studentSingnInfo.take_place=take_place
                    //   }
  
                    //   let sport_experience = '';
                    //   if(this.curStuInfo.studentSingnInfo.sport_experience && this.curStuInfo.studentSingnInfo.sport_experience !== '无'){
                    //     const temList = JSON.parse(this.curStuInfo.studentSingnInfo.sport_experience)
                    //     temList.forEach(letTmp =>{
                    //       if(letTmp){
                    //         let tmp1 = letTmp[0];
                    //         for(var x = 1;x<letTmp.length ; x++){
                    //           if(letTmp[x]){
                    //             tmp1 = tmp1 + '/' + letTmp[x] ;
                    //           }
                    //         }
                    //         sport_experience = sport_experience + tmp1 + '，';
                    //       }
                    //     })
                    //     sport_experience = sport_experience.substr(0, sport_experience.length - 1);
                    //     this.curStuInfo.studentSingnInfo.sport_experience=sport_experience
                    //   }
  
                    //   let coach_experience = '';
                    //   if(this.curStuInfo.studentSingnInfo.coach_experience && this.curStuInfo.studentSingnInfo.coach_experience !== '无'){
                    //     const temList = JSON.parse(this.curStuInfo.studentSingnInfo.coach_experience)
                    //     temList.forEach(letTmp =>{
                    //       if(letTmp){
                    //         let tmp1 = letTmp[0];
                    //         for(var x = 1;x<letTmp.length ; x++){
                    //           if(letTmp[x]){
                    //             tmp1 = tmp1 + '/' + letTmp[x] ;
                    //           }
                    //         }
                    //         coach_experience = coach_experience + tmp1+ '，';
                    //       }
                    //     })
                    //     coach_experience = coach_experience.substr(0, coach_experience.length - 1);
                    //     this.curStuInfo.studentSingnInfo.coach_experience=coach_experience
                    //   }
                    }
                });
            },
            changeType(val){
                if (val){
                    this.showAdd=false;
                    this.Peoplelist=this.selectedPeopleList
                }else{
                    this.showAdd=true;
                    this.Peoplelist=this.Peoplelist1
                }
            },
            goBack() {
                this.backComfim = true;
            },
              querySearch(queryString, cb) {
      let searchSuggestion = yioksStorage.getItem(SELECTSUGGESTIONlIST) || this.suggestionList;
      if(searchSuggestion && searchSuggestion.length) {
        if(queryString) {
          const filtersList = searchSuggestion.filter(str => {
            return str.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
          })
          cb(filtersList);
        } else {
          cb(searchSuggestion);
        }
      } else {
        cb([])
      }
      
    },
    handleSearch(row) {
      let searchSuggestion = yioksStorage.getItem(SELECTSUGGESTIONlIST);
      if(searchSuggestion && searchSuggestion.length) {
        const isExit = searchSuggestion.some(item => { return item.value == row.value})
        if(row.value && !isExit) {
          if(searchSuggestion.length >= 10) {
            searchSuggestion.shift();
          }
          searchSuggestion.push(item);
          yioksStorage.setItem(SELECTSUGGESTIONlIST, searchSuggestion);
          this.suggestionList = searchSuggestion
        }
      }
      this.search();
    },

    handleBtnSearch() {
      const { keywords } = this.selectVal;
      if(keywords) {
        let searchSuggestion = yioksStorage.getItem(SELECTSUGGESTIONlIST) || [];
        const isExit = searchSuggestion.some(item => {
          return item.value === keywords;
        })
        if(!isExit) {
          if(searchSuggestion.length >= 10) searchSuggestion.shift();
          searchSuggestion.push({
            value: keywords
          })
          this.suggestionList = searchSuggestion;
          yioksStorage.setItem(SELECTSUGGESTIONlIST, this.suggestionList);
        }
      }
      this.search();
    },

    updateCity(val) {
      if(val) {
        this.city_list = this.$yioks.updateCity(val, this.area_list)
        this.searchAddressForm.city_id = this.city_list[0].id
      } else {
        this.city_list = []
        this.searchAddressForm.city_id = ''
      }
    },
    handleSearchAddress() {
      this.get_choose_student_list();
      this.isShowAddress = false;
    },
    handleClearSearchAddress() {
      this.$set(this.searchAddressForm, 'province_id', '')
      this.$set(this.searchAddressForm, 'city_id', '')
      this.get_choose_student_list();
      this.isShowAddress = false;
    },
        },
        destroyed() {
            this.preTip=false;
            // yioksStorage.clearItem(SELECTSUGGESTIONlIST);
        }
    };
</script>

<style lang="stylus">
    @import '~@/assets/css/variable'
    @import '~@/assets/css/mixin'
    @import '~@/assets/css/linDialog'
    $page_main_height = 680px
    .edit_class-root, .create_class-root
        zuxie-page-root()
        .footer-btn
            .btns
                display: flex
                justify-content: center
                color: $color_white
                .btn
                    padding: 10px 25px
                    margin: 0 10px
                    border-radius: 4px
                    cursor: pointer
                    user-select: none
                .save
                    background-color: $color_suc
                .cancel
                    background-color: $color_err
        .main-content-wrap
            color $color_white
            .nav-wrap
                margin-bottom 20px
                .title
                    line-height 1
                    font-size $font_size_big
                .nav-right
                    color $color_err
                    margin-right 12px
            .post-btn, .form-tip
                display block
                text-align center
            .post-btn .cancel_btn
                background-color $color_err
            .content-wrap
                display block
                width 100%
                height 600px
                padding 15px 0 10px
                position relative
                background-color $block_bg_color_base
                margin-bottom: 15px
                .form-wrap
                    display block
                    width 100%
                    padding-right 25px
                    padding-left 25px
                    .table
                        display inline-block
                        width 100%
                        .item
                            display inline-block
                            width 19%
                            margin-left 8px
                            margin-bottom 20px
                            .tr
                                display inline-block
                                width 100%
                                position relative
                                border 1px solid $color_white
                                .td
                                    border-bottom 1px solid $color_white
                                    padding: 5px 2px 5px 3px
                                    font-size: 15px;
                                .user_img
                                    margin 5px 0
                                    display flex
                                    justify-content center
                                    align-items center
                                    img
                                        width 80px
                                        height 80px
                                        border-radius 50%
                                .user_name
                                    display flex
                                    justify-content center
                                    align-items center
                                    font-size 18px
                                    p
                                        over_hide()
                                    img
                                        margin-left 5px
                                        width 20px
                                .enroll_name
                                    p
                                        over_hide()
                                .opt
                                    display flex
                                    justify-content center
                                    align-items center
                                    border-bottom none
                                    .remove
                                        background-color red
                                        cursor pointer
                                        padding: 5px 17px;
                                        margin-right: 10px;
                                    .look
                                        .history,.detail
                                            cursor pointer
                                            color $color_suc

                                .error
                                    position absolute
                                    color red
                                    width 100%
                                    over_hide()
                                .close_btn
                                    position absolute
                                    right 0
                                    top 0
                                    width: 0;
                                    height: 0;
                                    border-bottom: 50px solid transparent;
                                    border-right: 50px solid #808080;
                                    border-left: 50px solid transparent;
                                    .icon_close
                                        cursor pointer
                                        position: relative;
                                        left: 28px;
                                        font-size: 18px;
                            .showError
                                border 1px solid $color_err

                        .splitLine
                            padding 0 10px
                            margin 20px 0
                            display flex
                            align-items center
                            .line
                                width 35%
                                height 0
                                border 2px solid $color_white
                            .intro
                                width 30%
                                font-size 20px
                                text-align center

    /*@import '~@/assets/css/CreateHighClass'*/
</style>

<style lang="stylus" >
    @import '~@/assets/css/mixin'
    @import '~@/assets/css/variable'
    .people-scroll
        .mainPeopleWrap
            height 610px
            .slot-dialog-header
                font-size 16px
                text-align center
            .searchWrap {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 40px;
                margin:20px 20px 0 20px
                .selectWrap {
                    height: 100%;
                    display: flex;
                    select {
                        width: 120px;
                        // width: 181px;
                        // height: 100%;
                        padding: 0 15px;
                        font-size: $font_size_medium;
                        color: $color_black;
                        outline: none;
                        &+select {
                            margin-left 15px
                        }
                    }
                }
                .search {
                    // width: 390px;
                    height: 100%;
                    display: flex;
                    justify-content: flex-end;
                    // align-items: center;
                    .wrap {
                        height: 100%;
                        position: relative;
                        border 1px solid rgb(169, 169, 169)
                        border-right none
                        input {
                            width: 155px;
                            height: 100%;
                            padding: 0 20px;
                            font-size: $font_size_medium;
                            color: $color_black;
                            outline: none;
                        }
                        .close {
                            position: absolute;
                            right: 5px;
                            top: 10px;
                            color: $color_info;
                            cursor: pointer;
                        }
                    }
                    .searchBtn {
                        width: 60px;
                        // height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 18px;
                        color $color_white
                        background-color: $color_suc;
                        cursor: pointer;
                        user-select: none;
                    }
                    .searchBtnNo {
                        width: 60px;
                        // height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 18px;
                        color $color_white
                        background-color: $color_background_grey;
                        cursor: no-drop;
                        user-select: none;
                    }
                }
            }
            .dialog-content
                height 500px
                overflow hidden
                .dia-scroll-content
                    .table {
                        width: 100%;
                        margin: 20px 0 0;
                        .thead, .tbody {
                            border: 1px solid $color_background_grey;
                        }
                        .thead {
                            margin: 0 20px;
                            .tr {
                                height: 45px;
                                display: flex;
                            }
                        }
                        .scrollArea {
                            height: 401px;
                        }
                        .tbodyWrap {
                            display block
                            margin-bottom 10px
                            // padding: 0 40px;
                        }
                        .tbody {
                            display block
                            margin-left auto
                            margin-right auto
                            width: 944px;
                            max-width: 944px;
                            border-top: none;
                            border-bottom: none;
                            .tr {
                                height: 49px;
                                display: flex;
                                border-bottom: 1px solid $color_background_grey;
                            }
                        }
                        .th, .td {
                            height: 100%;
                            flex: 1 1 auto;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 16px;
                            border-right: 1px solid $color_background_grey;
                        }
                        .th:last-child, .td:last-child {
                            border-right: none;
                        }
                        .td:last-child {
                            color: $color_suc;
                            user-select: none;
                        }
                        .td {
                            p {
                                over_hide();
                            }
                            .showRecord{
                                cursor pointer
                            }
                        }
                        .name {
                            width: 13%;
                            display flex
                            align-items center
                        }
                        .mobile_phone {
                            width: 10%;
                        }
                        .id_number {
                            width: 18%;
                        }
                        .enroll_name {
                            width: 8%;
                            display flex
                            justify-content center
                            .item{
                                cursor pointer
                                color $color_suc
                            }
                        }

                        .type{
                            width 15%
                        }
                        .admin_status {
                            width: 8%;
                        }
                        .socre{
                            width: 3%;
                        }
                        .opt {
                            width: 8%;
                            .gray_button{
                                background-color gray
                                border none
                            }
                        }
                    }

    .scroll-wrap
        height 630px
        .stu-info-box
            padding-right 20px
.flex-column
    flex-direction: column;
</style>

<style lang="stylus">
  // .select-admit
.yioks-wrapper
    .inline-input
        height 100%
    .el-input__inner
        height 40px !important
        width 160px !important
        border-radius 0px !important
        border 1px solid rgb(118, 118, 118) !important
        border-right none !important
</style>



